// extracted by mini-css-extract-plugin
module.exports = {"topMargin":"_3W3hGm3Cp9uHvfQKzqmCu1","row":"_3JxZzt0WzlOR8Kv9128dpJ"};